export enum CommodityPermissions {
  VIEW_COMMODITY = "view_commodity",
  CREATE_COMMODITY = "create_commodity",
  UPDATE_COMMODITY = "update_commodity",
  DELETE_COMMODITY = "delete_commodity",
  ARCHIVE_COMMODITY = "archive_commodity",
}

export const CommodityPermissionsText: Record<CommodityPermissions, string> = {
  [CommodityPermissions.VIEW_COMMODITY]: "View Commodity",
  [CommodityPermissions.CREATE_COMMODITY]: "Create Commodity",
  [CommodityPermissions.UPDATE_COMMODITY]: "Update Commodity",
  [CommodityPermissions.DELETE_COMMODITY]: "Delete Commodity",
  [CommodityPermissions.ARCHIVE_COMMODITY]: "Archive Commodity",
};
